import { render, staticRenderFns } from "./LowerThirdElement.vue?vue&type=template&id=77a33326&scoped=true&"
import script from "./LowerThirdElement.vue?vue&type=script&lang=js&"
export * from "./LowerThirdElement.vue?vue&type=script&lang=js&"
import style0 from "./LowerThirdElement.vue?vue&type=style&index=0&id=77a33326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a33326",
  null
  
)

export default component.exports